import styled from 'styled-components';

export const LoginWrapper = styled.div`
    margin-left: auto;
    margin-right: auto;
    background-color: white;
    padding: 20px;
    max-width: 320px;
    @media (min-width: 700px) {
        padding: 40px;
    }
`;